import { API } from "API/API";

async function getUser() {
  const response = await API.get.laravel("webshop/account", null, { next: { revalidate: 30 } });
  if (response?.success) {
    return response?.data;
  }
  return null;
}

async function get_prices() {
  const result = await API.get.laravel("webshop/products/prices");

  if (result?.success) {
    return result?.data;
  }
  return null;
}

async function get_price_ranges() {
  const result = await API.get.laravel("webshop/products/variation_ranges");
  if (result?.success) {
    return result?.data;
  }
  return null;
}

async function sendCodeMail(email, locale) {
  const response = await API.post.laravel("webshop/account/login", { email }, {}, { locale: locale });
  return response;
}

async function validateCode(email, token, locale) {
  const response = await API.post.laravel("webshop/account/auth", { email, token }, {}, { locale: locale });
  return response;
}

async function logout(locale) {
  const response = await API.post.laravel("webshop/account/logout", {}, {}, { locale: locale });
  return response;
}

export const login = {
  send_code: sendCodeMail,
  validate: validateCode,
  user: {
    get: getUser,
    logout: logout,
    prices: get_prices,
    variation_price_ranges: get_price_ranges,
  }
};